import { APIRequest } from "./helpers/requests";
import { API } from "../config";

export const trackingReportsService = {
    getOverview,
    getActivities,
    getDemandGeo,
};

async function getOverview(params) {
    return await APIRequest({
        url: API.TRACKING_REPORT_OVERVIEW + (params || ""),
        method: "GET",
        private: true,
    });
}

async function getActivities(params) {
    return await APIRequest({
        url: API.TRACKING_REPORT_ACTIVITIES + (params || ""),
        method: "GET",
        private: true,
    });
}

async function getDemandGeo(params) {
    return await APIRequest({
        url: API.TRACKING_REPORT_DEMAND_GEO + (params || ""),
        method: "GET",
        private: true,
    });
}
